var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-data-page flex-cen-xy"},[_c('div',{staticClass:"no-data-box flex-xy"},[_c('div',{staticClass:"no-data-image-box"},[_c('img',{attrs:{"src":require("../../assets/new-image/nodata/nodata.svg")}})]),_c('div',{staticClass:"text"},[_vm._v("暂无数据，可联系您的专属业务帮您解决问题")])])])
}]

export { render, staticRenderFns }